import React, { useContext } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";

const StatusBar = ({ title, pass, tag, link }) => {
    const { t } = useContext(LanguageContext);
    const linkRegex = /(https?:\/\/[^\s]+)/g;
    const hasLink = title.match(linkRegex);

    const getFormattedTitle = (title) => {
        const match = title.match(linkRegex);
        return match ? title.split(match[0])[0].trim() : title;
    };

    return (
        <div className="d-flex justify-content-between align-items-baseline gap-4 status-bar">
            <div>
                <p className="m-0 wrap-links" style={{ color: "#6C747A" }}>
                    {getFormattedTitle(title)}
                </p>
                {hasLink && (
                    <a
                        href={hasLink[0]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="article-table-tags bg-soft-secondary text-secondary justify-content-center"
                        title={hasLink[0]}
                        style={{ marginTop: '6px' }}
                    >
                        {new URL(hasLink[0]).hostname.length > 30
                            ? new URL(hasLink[0]).hostname.substring(0, 30) + "..."
                            : new URL(hasLink[0]).hostname}{" "}
                        <i className="bi bi-arrow-left-short fs-1" style={{ transform: "rotate(138deg)" }}></i>
                    </a>
                )}
            </div>
            <span
                className={`${pass ? "text-success bg-soft-success" : "text-danger bg-soft-danger"
                    } border-radius-5px d-flex justify-content-center align-items-center text-center`}
                style={{ minWidth: "44px", minHeight: "23px" }}
            >
                {pass ? t("Pass") : t("Fail")}
            </span>
        </div>
    );
};

export default StatusBar;
